import axios from 'axios'

// API 
export default axios.create({
    baseURL: 'https://shadowfinder.shreshtait.com'
});
